import React from 'react';
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { setKey, setStringifiedKey, clearKeys } from "../store/actions";
import keys from "../store/keys";
import adminService from "../services/admin";
import { swalName, swalPassword, swalError, swalSuccess } from "../utils/swal";
import Cookies from "universal-cookie";
import '../css/topbar.css';

function Topbar({ session, setKey, clearKeys, setStringifiedKey }) {
    const { t, i18n } = useTranslation();

    const switchLanguage = e => {
        e.preventDefault();
        const language = e.target.value;
        i18n.changeLanguage(language);
        const dir = language === "en" ? "ltr" : "rtl";
        document.getElementsByTagName("html")[0].setAttribute("dir", dir);
        setKey(keys.language, language);
        setKey(keys.direction, dir);
    };

    const handleUpdateName = e => {
        e.preventDefault();
        swalName(session.user.name, async newName => {
            await adminService.updateName(session.token, newName).then(result => {
                if (result.error) {
                    swalError(result.error);
                    return;
                }
                if (result.data) {
                    swalSuccess(t("name_updated"));
                    setStringifiedKey(keys.user, result.data);
                }
            });
        });
    };

    const handleUpdatePassword = e => {
        e.preventDefault();
        swalPassword(async (currentPassword, newPassword) => {
            await adminService.updatePassword(session.token, currentPassword, newPassword)
                .then(result => {
                    if (result.error) {
                        swalError(result.error);
                        return;
                    }
                    swalSuccess(t("password_updated"));
                });
        });
    };

    // NOTE: Logout is also in Sidebar, but we can keep it here or remove it. 
    // Keeping "Profile" actions here.

    if (!session.isLoggedIn) return null;

    return (
        <div className="topbar-container">
            <div className="topbar-left">
                <h4 className="topbar-welcome">{t("welcome_back")}, {session.user?.name ? session.user.name.split(' ')[0] : 'Admin'} 👋</h4>
            </div>

            <div className="topbar-right">
                <div className="topbar-item">
                    <select
                        className="form-control-modern topbar-select"
                        defaultValue={i18n.language || "en"}
                        onChange={switchLanguage}
                    >
                        <option value="en">English 🇺🇸</option>
                        <option value="ar">عربي 🇸🇦</option>
                    </select>
                </div>

                <div className="topbar-item dropdown">
                    <button
                        className="btn-modern btn-outline-modern dropdown-toggle"
                        type="button"
                        id="userMenu"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <i className="fa fa-user-circle"></i> {t("account")}
                    </button>
                    <div className="dropdown-menu dropdown-menu-right shadow-lg border-0" aria-labelledby="userMenu">
                        <button className="dropdown-item" onClick={handleUpdateName}>
                            <i className="fa fa-signature mr-2"></i> {t("update_name")}
                        </button>
                        <button className="dropdown-item" onClick={handleUpdatePassword}>
                            <i className="fa fa-key mr-2"></i> {t("change_password")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = store => ({
    session: store.session
});

const mapDispatchToProps = dispatch => ({
    setKey: (key, value) => dispatch(setKey(key, value)),
    clearKeys: () => dispatch(clearKeys()),
    setStringifiedKey: (key, value) => dispatch(setStringifiedKey(key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(Topbar);
